<style scoped lang="scss">
  .logo{
    text-align: center;
    padding:50px 0;
    img{
      width:40%;
    }
  }
  .bind-con{
    padding:0 30px;
    li{
      display: flex;
      align-items: center;
      padding:18px 0 10px;
      border-bottom: 1px solid #014492;
      .icon{
        width:20px;
        margin-right: 10px;
      }
    }
    .get-code{
      background: linear-gradient(45deg, #014492, #6EC8E2);
      padding:5px 10px;
      border:0;
      color:#fff;
      min-width: 50px;
      outline: none;
    }
  }
</style>
<template>
  <div class="wrap-app">
    <div class="logo">
      <img src="@/assets/images/mobile/logo_2.png">
    </div>
    <div class="bind-con">
      <ul class="bind-form">
        <li>
          <img src="@/assets/images/mobile/icon_phone2.png" class="icon">
          <input type="number" v-model="phone" placeholder="请输入手机号码">
        </li>
        <li>
          <img src="@/assets/images/mobile/icon_code.png" class="icon">
          <input type="number" v-model="captcha" placeholder="请输入验证码" class="flex-1">
          <button class="get-code" @click="getCode" v-if="timesCount === 0">获取验证码</button>
          <button class="get-code" v-else>{{ timesCount }}</button>
        </li>
      </ul>
      <button class="btn btn-sencond btn-block mt50" @click="loginSms">绑定手机号</button>
    </div>
  </div>
</template>

<script>
import { loginForSms, smsSend } from '@/services/api.index'
export default {
  data () {
    return {
      phone: '',
      captcha: '',
      timesCount: 0
    }
  },
  methods: {
    // 发送验证码
    getCode () {
      const { phone } = this
      if (phone === '' || !this.baseMethods.checkPhone(phone)) {
        return this.$toast('请输入正确的手机号')
      }
      this.timesCount = 60
      let timer = setInterval(() => {
        if (this.timesCount > 0) {
          this.timesCount--
        } else {
          clearInterval(timer)
        }
      }, 1000)
      smsSend(this.phone).then(() => {
        this.$toast('发送成功')
      })
    },
    // 短信登录
    loginSms () {
      const { phone, captcha } = this
      if (phone === '' || !this.baseMethods.checkPhone(phone)) {
        return this.$toast('请输入正确的手机号')
      }
      if (captcha === '') {
        return this.$toast('请输入验证码')
      }
      loginForSms(phone, captcha).then(async (res) => {
        this.$toast('登录成功')
        this.baseMethods.setLocalObj('userInfo', res.data)
        localStorage.setItem('username', phone)
        localStorage.setItem('token',res.data.token)
        this.baseMethods.hrefUrl('/mobile')
        await this.$store.dispatch('memberInfo')
        await this.$store.dispatch('courseInfo')
      }).catch(res => {
        if (res.status === 427 || res.status === 428 || res.status === 429) {
          this.toAccountStatus(res.status)
        }
      })
    },
    // 跳转到登录状态
    toAccountStatus (code) {
      let status
      switch (code) {
        case 427: // 审核中
          status = 2
          break
        case 428: // 拒绝
          status = 1
          break
        case 429: // 冻结
          status = 0
          break
      }
      localStorage.clear()
      this.$router.push(`/mobile/account_status?status=${status}`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/mobile/bind.vue